import React from 'react';
import type { FC } from 'react';
import { match } from 'variant';
import { Trans, useTranslation } from '@wix/cli-i18n';
import type { AsyncCallbackStatus } from '@wix/cli-ui-kit';
import { Text, Spinner } from '@wix/cli-ui-kit';
import type { Site } from '@wix/site-list-client';
import { WaitForAppToBeInstalled } from './WaitForAppToBeInstalled.js';

interface Props {
  status: AsyncCallbackStatus<Site>;
  appId: string;
  onSubmit: (site: Site) => void;
  onError: (error: unknown) => void;
}

export const CreateDevSite: FC<Props> = ({
  status,
  appId,
  onSubmit,
  onError,
}) => {
  const { t } = useTranslation();

  return match(status, {
    NotRequested: () => null,
    Error: () => null,
    Loading: () => <Spinner text={t('create_dev_site.loading')} />,
    Success: ({ result }) => (
      <>
        <Trans
          i18nKey="create_dev_site.success"
          components={[<Text skin="success" bold />]}
          values={{ name: result.displayName }}
        />
        <WaitForAppToBeInstalled
          appId={appId}
          site={result}
          onSubmit={() => onSubmit(result)}
          onError={onError}
        />
      </>
    ),
  });
};
